export default function WorkflowSolutions() {
  const solutions = [
    {
      title: '医疗保健行业',
      description: '实施电子健康记录(EHR)系统，支持电子处方，提高患者记录维护的效率和准确性，改善医疗服务质量。',
      icon: 'ri-heart-pulse-line',
      features: ['电子病历管理', '处方自动化', '患者数据安全', '合规性保障']
    },
    {
      title: '法律服务行业',
      description: '加快文件起草、审核和归档流程，高效管理案件卷宗，保障合规性并优化对必要文件的访问控制。',
      icon: 'ri-scales-3-line',
      features: ['案件文档管理', '合同审核流程', '法律合规追踪', '安全归档系统']
    },
    {
      title: '制造业',
      description: '有效管理和跟踪设计文档、规格和合规性记录，确保制造流程符合监管标准，保持产品质量。',
      icon: 'ri-settings-4-line',
      features: ['设计文档管理', '质量控制记录', '供应链文档', '合规性追踪']
    },
    {
      title: '金融银行业',
      description: '数字化和简化文档流程，减少手动数据输入，加快交易时间，确保财务规定和审计的合规性。',
      icon: 'ri-bank-line',
      features: ['交易文档处理', '风险管理文档', '审计追踪', '监管合规']
    },
    {
      title: '教育机构',
      description: '管理学生档案、教学资料和行政文档，提高教育管理效率，确保数据安全和隐私保护。',
      icon: 'ri-book-open-line',
      features: ['学生档案管理', '教学资源库', '成绩记录系统', '招生文档处理']
    },
    {
      title: '政府机构',
      description: '建立标准化的公文流转系统，提高行政效率，确保政务信息的安全性和可追溯性。',
      icon: 'ri-government-line',
      features: ['公文流转', '档案管理', '信息公开', '电子政务']
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            行业解决方案
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            针对不同行业特点，提供定制化的文档工作流程解决方案
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {solutions.map((solution, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl border border-gray-200 overflow-hidden hover:shadow-xl transition-all duration-300 group cursor-pointer"
            >
              <div className="p-8">
                <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-teal-600 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                  <i className={`${solution.icon} text-3xl text-white`}></i>
                </div>
                
                <h3 className="text-2xl font-bold text-gray-900 mb-3">
                  {solution.title}
                </h3>
                
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {solution.description}
                </p>
                
                <div className="space-y-2">
                  {solution.features.map((feature, idx) => (
                    <div key={idx} className="flex items-center gap-2">
                      <i className="ri-checkbox-circle-fill text-teal-500 text-sm"></i>
                      <span className="text-sm text-gray-600">{feature}</span>
                    </div>
                  ))}
                </div>
              </div>
              
              <div className="px-8 pb-8">
                <a 
                  href="/contact"
                  className="inline-flex items-center text-teal-600 font-medium hover:text-teal-700 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                >
                  <span>了解详情</span>
                  <i className="ri-arrow-right-line ml-2"></i>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
